import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectAuditComponentDomain = state => state.auditComponentReducer || initialState;

export const getAuditDataSelector = () => createSelector(selectAuditComponentDomain, ({ auditData }) => auditData);

export const getIsAuditDataLoadingSelector = () =>
	createSelector(selectAuditComponentDomain, ({ isAuditDataLoading }) => isAuditDataLoading);
